module.exports = __webpack_public_path__ + "img/trip_17.55b3cfc6.jpg";